import { useMutation, useQueryClient } from '@tanstack/react-query'

import type {
  BookingSessionResponse,
  SubmitPassengersRequest,
} from '../../types/booking-session.js'

import { apiClient } from '../../lib/client.js'
import { syncBookingSessionCache } from './cache.js'
import { bookingSessionKeys } from './keys.js'

export const useSubmitPassengers = (
  sessionId: string,
  { throwOnError = false }: { throwOnError?: boolean }
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: SubmitPassengersRequest) => {
      const response = await apiClient.client.post<BookingSessionResponse>(
        `/booking-session/${sessionId}/passengers`,
        data
      )
      return response.data
    },
    onSuccess: (data) => {
      syncBookingSessionCache(queryClient, data)
      queryClient.setQueryData(bookingSessionKeys.price(sessionId), data)
    },
    throwOnError,
  })
}
